/* RESPONSIBLE TEAM: team-inbox */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import AdminSummary, { type AdminSummaryWireFormat } from 'embercom/objects/inbox/admin-summary';
import { EntityType } from 'embercom/models/data/entity-types';

interface CompanyUpdatedWireFormat {
  renderable_type: RenderableType;
  admin_summary: AdminSummaryWireFormat;
  company_name: string;
  company_id: string;
}

export default class CompanyUpdated implements RenderableData {
  readonly renderableType = RenderableType.CompanyUpdated;
  readonly admin: AdminSummary;
  readonly companyId: string;
  readonly companyName: string;

  constructor(admin: AdminSummary, companyId: string, companyName: string) {
    this.admin = admin;
    this.companyId = companyId;
    this.companyName = companyName;
  }

  get adminSummary() {
    return this.admin;
  }

  get creatingEntity() {
    return {
      type: EntityType.Admin,
      id: this.admin.id,
      object: this.admin,
    };
  }

  get adminOnly() {
    return true;
  }

  get styles() {
    return {
      backgroundColor: 'bg-beta-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-beta-container-emphasis',
    };
  }

  static deserialize(json: CompanyUpdatedWireFormat): CompanyUpdated {
    let adminSummary = AdminSummary.deserialize(json.admin_summary);
    return new CompanyUpdated(adminSummary, json.company_id, json.company_name);
  }
}
